import React, { useState } from 'react'

import {
	EuiButton,
	EuiFieldText,
	EuiFormRow,
	EuiModalFooter,
	EuiModalBody,
} from '@equipmentshare/ds2'

import CurrencyField from 'components/CurrencyField/currencyField'

import { Role } from 'graphql'

export type RoleFormProps = {
	onCancel: () => void,
	onSuccess: () => void,
	onSubmit: ( name: string, spendingLimit: string ) => Promise<any>,
	role?: Role,
	onDeleteClick?: () => void,
}

export default function RoleForm( { onCancel, onSuccess, onSubmit, role, onDeleteClick }: RoleFormProps ) {
	const [ isSaving, setIsSaving ] = useState( false )
	const [ name, setName ] = useState( role?.name ?? '' )
	const [ spendingLimit, setSpendingLimit ] = useState( role?.spendingLimit?.toString() ?? '' )

	const handleSubmit = async() => {
		setIsSaving( true )
		await onSubmit( name, spendingLimit )
		setIsSaving( false )
		onSuccess()
	}

	return (
		<>
			<EuiModalBody>
				<EuiFormRow label="Role Name">
					<EuiFieldText
						id="name"
						onChange={( e ) => setName( e.currentTarget.value )}
						value={name}
					/>
				</EuiFormRow>
				<EuiFormRow label="Spending Limit">
					<CurrencyField
						id="spendingLimit"
						min={0}
						onRawChange={( value ) => setSpendingLimit( value )}
						value={spendingLimit}
					/>
				</EuiFormRow>
			</EuiModalBody>
			<EuiModalFooter>
				{ onDeleteClick !== undefined && (
					<EuiButton
						onClick={onDeleteClick}
						color="danger"
						style={{ marginRight: 'auto' }}
					>
						Delete role
					</EuiButton>
				) }
				<EuiButton
					color="text"
					onClick={onCancel}
				>
					Cancel
				</EuiButton>
				<EuiButton
					id="submitBtn"
					isLoading={isSaving}
					fill
					onClick={handleSubmit}
				>
					Submit
				</EuiButton>
			</EuiModalFooter>
		</>
	)
}
